import { render, staticRenderFns } from "./paymentOrderStat.vue?vue&type=template&id=e23adb14&scoped=true&"
import script from "./paymentOrderStat.vue?vue&type=script&lang=js&"
export * from "./paymentOrderStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23adb14",
  null
  
)

export default component.exports